import React, { useEffect, useState } from "react";
import Logo from "../../../Images/new logo 2.png";
import MenuIcone from "../../../Images/menuicone.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaArrowUp, FaRegClipboard } from "react-icons/fa";
import { SiHelpscout } from "react-icons/si";
import { LuLogOut } from "react-icons/lu";
import { IoNewspaperOutline } from "react-icons/io5";
import { TbBuildingBank } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { HiMenuAlt2 } from "react-icons/hi";
import { useUser } from "../../../hooks/use-user";
import { BsGlobe } from "react-icons/bs";
import { FaAward, FaWallet } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaArtstation } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { IoMdLogOut } from "react-icons/io";
import { TbBrandStackshare } from "react-icons/tb";
import {
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaCopy,
} from "react-icons/fa";
import { motion } from "framer-motion";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,   
  useDisclosure,
} from "@chakra-ui/react";
import axios from "../../../axios";
import DemoUser from"../../../Images/demoUserForNavbar.jpg";
const Navbar = () => {
  const { data: user } = useUser();
  // console.log(user);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuOpen2, setIsMenuOpen2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [vlaue, setVlue] = useState("");
  const [pro, setPro] = useState("");
  const [customMessage, setCustomMessage] = useState("");
  const [copied, setCopied] = useState(false);
  const isContestValid = user?.isContestValid === true;
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropdown = () => {
    setIsOpen1(!isOpen1);
  };
  const toggleMenu2 = () => {
    setIsMenuOpen2(!isMenuOpen2);
    console.log("clcik");
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const closeMenu2 = () => {
    setIsMenuOpen2(false);
  };

  const [t, i18n] = useTranslation();

  const stHinmdi = () => {
    //  console.log(i18n.language)
    if (i18n.language == "en") {
      i18n.changeLanguage("hi");
    } else if (i18n.language == "hi") {
      i18n.changeLanguage("en");
    }
  };
  const ChageLang = (lang) => {
    if (lang == "en") {
      i18n.changeLanguage("en");
      setShowModal(false);
      // setMobileOpen(false);
    } else if (lang == "hi") {
      i18n.changeLanguage("hi");
      setShowModal(false);
      // setMobileOpen(false);
    }
  };
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setShowModal(false);
  };
 useEffect(() => {
  if (!user) return;

  // 👇 phone login hua ho to demo image
  if (user.loginType === "phone") {
    setPro(DemoUser);
  } else {
    // 👇 google / email login
    setPro(user.profilePicUrl || DemoUser);
  }
}, [user]);

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "flex items-center p-2 text-purple bg-purple-100 rounded-lg dark:text-purple-400 group font-bold"
      : "flex items-center p-2 text-gray-900 rounded-lg dark:text-black group font-bold";
  };
  const [referralCode, setReferralCode] = useState("");

  useEffect(() => {
    const fetchReferralCode = async () => {
      try {
        const res = await axios.get("/referral/stats");
        if (res.data?.result?.referralCode) {
          setReferralCode(res.data.result.referralCode);
        }
      } catch (error) {
        console.error("Referral code fetch error", error);
      }
    };
    fetchReferralCode();
  }, []);

  const shareableLink = referralCode
    ? `https://learn2earn24x7.com/login?ref=${referralCode}`
    : "";

  const handleShare = (platform) => {
    const shareText = `Join Learn2Earn24x7 and start earning while learning! Use my referral code: ${referralCode}\n${shareableLink}`;
    let url;
    switch (platform) {
      case "whatsapp":
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          shareText
        )}`;
        break;
      case "instagram":
        url = `https://instagram.com/share?url=${encodeURIComponent(
          shareableLink
        )}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareableLink
        )}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          shareableLink
        )}&text=${encodeURIComponent(customMessage)}`;
        break;
      default:
        return;
    }
    window.open(url, "_blank");
  };

  const copyToClipboard = () => {
    try {
      navigator.clipboard.writeText(shareableLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Clipboard write failed", err);
    }
  };

  return (
    <>
      <nav className="bg-white border-gray-200 fixed top-0 w-full z-50  lg:h-20 h-16 ">
        {/* <div className="flex items-center justify-between "> */}
        {/* Hamburger Icon on the left side */}
        {/* <button
            type="button"
            className="flex items-center text-sm md:hidden"
            onClick={toggleMenu}
          >
            <HiMenuAlt2 size={30} />
          </button> */}

        {/* Logo in the center */}
        <nav className="bg-white border-gray-200 fixed top-0 left-0 w-full z-50 shadow-xl lg:h-20 h-16">
          <div className="flex items-center justify-between lg:p-4 p-2 ">
            {/* Hamburger Icon on the left side */}
            <button
              type="button"
              className="flex items-center text-sm md:hidden pl-2"
              onClick={toggleMenu}
            >
              {/* <HiMenuAlt2 size={30} /> */}
              <img src={MenuIcone} alt="" className="w-10" />
            </button>

            {/* Logo in the center */}
            <div className="flex-grow flex justify-center md:justify-start  invisible md:visible">
              <a
                href="/"
                className="flex items-center space-x-3 rtl:space-x-reverse md:visible "
              >
                <img
                  src={Logo}
                  className="lg:w-32 w-28 md:visible"
                  alt="Learn2Earn24x7 Logo"
                />
              </a>
            </div>

            {/* Avatar on the right side */}
            <div className="flex items-center gap-2">
              <div className="text-start hidden  lg:block">
                <p className="text-lg font-bold text-bgBlue ">{user?.name}</p>
                <p className="text-bgBlue">{user?.email}</p>
              </div>
              <button
                onClick={toggleMenu2}
                className="flex text-sm bg-bgBlue rounded-full focus:ring-2 focus:ring-bgBlue dark:focus:ring-bgBlue mr-4 "
              >
                <img
                  className="w-10 lg:w-12  rounded-full bg-bgBlue"
                  src={pro || DemoUser}
                  alt="user photo"
                />
              </button>
            </div>

            {/* <div
                className={`w-40 absolute z-50 right-4 top-0   ${
                  isMenuOpen2 ? "" : "hidden"
                } text-base list-none bg-bgBlue divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600`}
                id="user-dropdown"
              >
                <button
                  type="button"
                  className="absolute top-0 right-0 p-2 text-gray-400 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 font-semibold"
                  onClick={closeMenu2}
                >
                  <svg
                    className="w-6 h-6 font-semibold"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                <ul
                  className="py-8 flex flex-col justify-start text-start px-4 font-oswald font-semibold"
                  aria-labelledby="user-menu-button"
                >
                  <li>
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600  dark:hover:text-white"
                    >
                      My Account
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                    >
                      Wallet
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      localStorage.removeItem("logintoken");
                      window.location.reload();
                      // history.push("/mainPage5data");
                    }}
                  >
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600  dark:hover:text-white"
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </div> */}
          </div>
        </nav>

        {/* Avatar on the right side */}
        {/* <div className="flex items-center gap-2">
            <button
              onClick={toggleMenu2}
              className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
            >
              <img className="w-14  rounded-full" src={pro} alt="user photo" />
            </button>
            <div className="text-start">
              <p className="text-lg font-bold text-bgBlue">{user?.name}</p>
              <p className="text-bgBlue">{user?.email}</p>
            </div>
          </div> */}

        {/* <div
          className={`w-60 absolute z-50 right-4 top-16 border border-purple p-2  ${
            isMenuOpen2 ? "" : "hidden"
          } text-base list-none bg-bgWhite rounded-xl`}
          id="user-dropdown"
        >
          <button
            type="button"
            className="absolute top-0 right-0 p-2 text-purple hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 font-semibold"
            onClick={closeMenu2}
          >
            <svg
              className="w-6 h-6 font-semibold"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <br />
          <div className="w-full flex flex-col justify-center items-center ">
            <div className="flex flex-col gap-2 justify-center items-center  text-bgBlue font-oswald  ">
              <div className="w-1/3 m-auto ">
                <img src={pro} alt="" className="rounded-full border  m-auto" />
              </div>

              <div className=" ">
                <h1 className="text-sm font-bold">{user?.name}</h1>

                <p className="text-sm">{user?.email}</p>
              </div>
            </div>
            <div className="w-full flex gap-4 justify-between items-center p-2  text-bgBlue font-oswald  ">
              <div className="ml-4 ">
                <p className="text-sm text-green font-semibold">
                  Active Course
                </p>
              </div>

              <div className=" mr-4 text-purple cursor-pointer">
                <IoMdLogOut
                  size={25}
                  onClick={() => {
                    localStorage.removeItem("token");
                    navigate("/login");
                  }}
                />
              </div>
            </div>
          </div>
        </div> */}
       <div
  className={`w-64 absolute z-50 right-4 top-16 
  ${isMenuOpen2 ? "block" : "hidden"}
  rounded-2xl p-[2px] 
  bg-gradient-to-br from-purple via-purple to-orange shadow-2xl  border-4 border-bgBlue`}
  id="user-dropdown"
>
  {/* Inner Card */}
  <div className="relative rounded-2xl bg-gradient-to-b from-purple/90 to-purple/70 px-4 py-6 text-white">

    {/* Close Button */}
    <button
      type="button"
      className="absolute top-3 right-3 text-orange hover:rotate-90 transition-transform"
      onClick={closeMenu2}
    >
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    {/* Profile */}
    <div className="flex flex-col items-center gap-3">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-orange to-yellow p-[3px]">
        <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
          <img
            src={pro}
            alt="profile"
            className="w-full h-full rounded-full object-cover"
          />
        </div>
      </div>

      {/* User Info */}
      <div className="text-center">
        <h1 className="text-lg font-bold tracking-wide">
          {user?.name}
        </h1>
        <p className="text-sm text-white/80 break-all">
          {user?.email}
        </p>
      </div>

      {/* Active Course Badge */}
      <div className=" px-5 py-2 rounded-full 
        bg-gradient-to-r from-bgBlue to-bgBlue 
         font-bold text-sm shadow-lg animate-pulse border-2">
        ● Active Course
      </div>
    </div>

    {/* Divider */}
    <div className="my-4  bg-white/20"></div>

    {/* Logout */}
    <button
      onClick={() => {
        localStorage.removeItem("token");
        navigate("/login");
      }}
      className="w-full flex items-center justify-center gap-2 
      py-2 rounded-xl 
      bg-white text-purple font-bold 
      hover:bg-orange hover:text-white 
      transition-all border-2 border-bgBlue"
    >
      <IoMdLogOut size={22} />
      Logout
    </button>
  </div>
</div>

      </nav>

      {/* Sidebar */}
      <div
        className={`fixed inset-0 z-50 transition-transform transform ${
          isMenuOpen ? "translate-x-0" : "-translate-x-full"
        } md:hidden`}
      >
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75"
          onClick={closeMenu}
        ></div>
        <div className="relative w-64 bg-white h-full shadow-xl z-50">
          <div className="flex justify-end items-center p-4 border-b border-gray-200">
            <div className="flex-grow flex  ">
              <a
                href="/"
                className="flex items-center space-x-3 rtl:space-x-reverse  "
              >
                <img src={Logo} className="w-28" alt="Learn2Earn24x7 Logo" />
              </a>
            </div>
            {/* <span className="text-lg font-semibold">Menu</span> */}
            <button
              type="button"
              className="text-gray-600 hover:text-gray-800 "
              onClick={closeMenu}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <ul className="space-y-2 font-medium font-oswald font-bold p-4">
            <li onClick={closeMenu}>
              <Link to="/dash/home" className={getLinkClass("/dash/home")}>
                <MdDashboard className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Dashboard</span>
              </Link>
            </li>
            <hr className="" />
            {user?.planName !== "TEST" && (
              <>
                <li onClick={closeMenu}>
                  <Link
                    to="/dash/quize"
                    className={getLinkClass("/dash/quize")}
                  >
                    <FaArtstation className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                    <span className="ms-3 text-lg font-semibold"> Quiz</span>
                  </Link>
                </li>
                <hr />
              </>
            )}
            <li onClick={closeMenu}>
              <Link to="/dash/plan" className={getLinkClass("/dash/plan")}>
                <IoNewspaperOutline className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Course</span>
              </Link>
            </li>
           
           {isContestValid && (
            <>
            <hr/>
            <li onClick={closeMenu}>
              <Link
                to="/dash/contest"
                className={getLinkClass("/dash/contest")}
              >
                <FaAward className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Contest</span>
              </Link>
            </li>
            </>
           )}
            <hr />
            <li onClick={closeMenu}>
              <Link to="/dash/wallet" className={getLinkClass("/dash/wallet")}>
                <FaWallet className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold" >Wallet</span>
              </Link>
            </li>
            <hr /> 
            <li onClick={onOpen}>
              <Link to="" className={getLinkClass("/dash/referral")}>
                <TbBrandStackshare className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Referral</span>
              </Link>
            </li>
            <hr />
            <Modal
              isOpen={isOpen}
              onClose={onClose}
              size={"sm"}
              backgroundColor="purple"
              colorScheme="purple"
              className="bg-bgBlue"
            >
              <ModalOverlay />
              <ModalContent
                borderRadius={"20px"}
                backgroundColor={"#4D2C5E"}
                className="bg-bgBlue"
              >
                <ModalHeader
                  fontWeight={"700"}
                  className="font-bold text-xl text-center text-white underline underline-purple"
                >
                  Refer And Earn
                </ModalHeader>
                <ModalCloseButton color={"#FF782D"} className="text-purple" />
                <ModalBody>
                  <div className="max-w-md mx-auto bg-bgBlue rounded-xl  overflow-hidden md:max-w-2xl ">
                    <div className="p-4">
                      <h2 className="text-2xl font-bold text-white mb-4">
                        Share This Link
                      </h2>

                      <div className="relative mb-6">
                        <input
                          type="text"
                          value={shareableLink || "Loading..."}
                          readOnly
                          className="w-full pr-10 py-2 pl-3 border border-purple rounded-md focus:outline-none focus:ring-2 focus:ring-purple text-sm"
                        />
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className="absolute inset-y-0 right-0 px-3 flex items-center bg-purple text-white rounded-r-md"
                          onClick={copyToClipboard}
                          aria-label="Copy link"
                        >
                          <FaCopy size={18} />
                        </motion.button>
                      </div>
                      <div className="mb-4">
                        <p className="text-white text-sm mb-1">Your Referral Code:</p>
                        <div className="bg-white bg-opacity-10 rounded-lg p-3 text-center">
                          <p className="text-white text-xl font-bold tracking-widest">{referralCode || "Loading..."}</p>
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-4">
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="bg-green-500 text-white p-3 rounded-full"
                          onClick={() => handleShare("whatsapp")}
                          aria-label="Share on WhatsApp"
                        >
                          <FaWhatsapp size={24} />
                        </motion.button>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="bg-pink-500 text-white p-3 rounded-full"
                          onClick={() => handleShare("instagram")}
                          aria-label="Share on Instagram"
                        >
                          <FaInstagram size={24} />
                        </motion.button>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="bg-blue-600 text-white p-3 rounded-full"
                          onClick={() => handleShare("facebook")}
                          aria-label="Share on Facebook"
                        >
                          <FaFacebook size={24} />
                        </motion.button>
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          className="bg-blue-400 text-white p-3 rounded-full"
                          onClick={() => handleShare("twitter")}
                          aria-label="Share on Twitter"
                        >
                          <FaTwitter size={24} />
                        </motion.button>
                      </div>

                      <div className=" flex flex-col lg:flex-row lg:justify-between justify-center items-center lg:text-start text-center  text-md font-bold ">
                        <p className="w-40 flex py-2  justify-center items-center gap-1 rounded-full bg-white text-bgBlue transition duration-300 mt-2 ">
                          Referral Code: {referralCode || "—"}
                        </p>
                        <Link
                          to={"/dash/referral"}
                          className="flex justify-center"
                        >
                          <div className="w-40 flex py-2  justify-center items-center gap-1 rounded-full bg-purple text-white transition duration-300 mt-2 ">
                            <button className="font-bold cursor-pointer text-sm">
                              Dashboard
                            </button>
                            <FaArrowUp
                              color="white"
                              className="text-white"
                              size={18}
                            />
                          </div>
                        </Link>
                      </div>

                      {copied && (
                        <motion.p
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 10 }}
                          className="text-green-600 text-sm mt-2"
                        >
                          Link copied to clipboard!
                        </motion.p>
                      )}
                    </div>
                    <h1 className="text-white p-2 text-lg font-bold text-center">
                      Every Referral You Get 100 Rs
                    </h1>
                    <p className="text-white p-2 text-sm">
                      Earn reward points for each valid referral who signs up
                      using your link and get course . Rewards are credited to
                      your account and are non-transferable and
                      non-exchangeable.
                    </p>
                  </div>
                </ModalBody>

                <ModalFooter>
                  <Button
                    colorScheme="#FF782D"
                    className="bg-purple"
                    mr={3}
                    onClick={onClose}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
            <li onClick={toggleDropdown}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                  isOpen1 ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center">
                  <BsGlobe className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3 text-lg font-semibold">Language</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col items-center justify-center mt-2 text-end ${
                  isOpen1 ? "" : "hidden"
                }`}
              >
                <li
                  className="flex items-center  w-full  text-bgBlue font-bold text-lg pl-10 cursor-pointer"
                  onClick={() => changeLanguage("hi")}
                >
                  <GoDotFill className="text-purple mr-2" size={25} /> हिन्दी
                </li>
                <li
                  className="flex items-center  w-full  text-bgBlue font-bold text-lg pl-10 cursor-pointer"
                  onClick={() => changeLanguage("en")}
                >
                  <GoDotFill className="text-purple mr-2" size={25} /> English
                </li>
              </ul>
            </li>
            <hr />
            <li>
              <Link className={getLinkClass("/support")}>
                <SiHelpscout className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Support</span>
              </Link>
            </li>
            <hr />
            <li
              onClick={() => {
                localStorage.removeItem("token");
                // Notify other tabs
                const bc = new BroadcastChannel("auth");
                bc.postMessage("logout");
                navigate("/login");
              }}
            >
              <Link className={getLinkClass("/logout")}>
                <LuLogOut className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Logout</span>
              </Link>
            </li>
            <hr />
          </ul>
        </div>
        {/* {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none ">
              <div className="relative w-80 my-6 mx-auto max-w-sm bg-bgBlue  rounded-3xl">
                
                <div className=" rounded-3xl shadow-lg relative flex flex-col w-full bg-bgBlue ">
                 
                  <div className="flex items-start justify-between p-4  ">
                    <h3 className="text-xl font-semibold text-bgBlue">
                      {t("Select Language")}
                    </h3>
                    <button
                      className="  text-white float-right  leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setShowModal(false)}
                    >
                      <span className=" text-white  h-6 w-6 text-2xl  outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>
                
                  <div className="relative p-6 flex-auto ">
                    <div
                      className="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]"
                      onClick={() => {
                        setVlue("en");
                      }}
                    >
                      <input
                        className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                        type="radio"
                        name="flexRadioDefault"
                        id="radioDefault01"
                        
                      />
                      <label
                        className="mt-px inline-block pl-[0.15rem] hover:cursor-pointer text-white ml-4 text-16"
                        htmlFor="radioDefault01"
                      >
                        {t("English")}
                      </label>
                    </div>
                    <br />
                    <div
                      className="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem] "
                      onClick={() => {
                        setVlue("hi");
                      }}
                    >
                      <input
                        className="relative float-left -ml-[1.5rem] mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-neutral-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                        type="radio"
                        name="flexRadioDefault"
                        id="radioDefault02"
                        
                      />
                      <label
                        className="mt-px inline-block pl-[0.15rem] hover:cursor-pointer text-white ml-4 text-16"
                        htmlFor="radioDefault02"
                      >
                        {t("Hindi")}
                      </label>
                    </div>
                    <div className="flex items-right justify-end p-6 rounded-b py-4 ">
                      <button
                        className=" text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 "
                        type="button"
                        onClick={() => ChageLang(vlaue)}
                        
                      >
                        {t("OK")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null} */}
      </div>
    </>
  );
};

export default Navbar;
